const BASE_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:4700';

export const API_ROUTES = {
  Project: {
    CREATE: BASE_URL+'/api/project',
    ALL: BASE_URL+'/api/project/all',
    LANDING_PAGE_DATA: BASE_URL+'/api/project/landing/data',
    DELETE: BASE_URL+'/api/project/',
    UPDATE: BASE_URL+'/api/project/',
  },
  Auth: {
    LOGIN: BASE_URL+'/api/auth/login',
  },
  REQUEST: {
    CREATE: BASE_URL+'/api/request',
    ALL: BASE_URL+'/api/request/all',
    DELETE: BASE_URL+'/api/request/',
    UPDATE: BASE_URL+'/api/request/',
  },
}